import { Component } from "@builder.io/sdk";

export const customJsonLdConfig: Component = {
  name: "CustomJsonLd",
  inputs: [
    {
      name: "data",
      type: "longText",
      helperText:
        "Custom JSON-LD data for the website (Use schema.org to build your schema and paste it here)",
      required: true,
    },
  ],
};
